import { useState, useMemo, ReactNode} from 'react';
import VideoContext from './VideoContext';

interface VideoProviderProps {
  children: ReactNode;
};

function VideoProvider({ children }: VideoProviderProps) {
  const [isVideo, setIsVideo] = useState<boolean>(false);
  const [srcId, setSrcId] = useState<string>('');
  const [videoSrc, setVideoSrc] = useState<string>('');

  const videoContextValues = useMemo(() => ({
    isVideo,
    setIsVideo,
    srcId,
    setSrcId,
    videoSrc,
    setVideoSrc,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [isVideo, srcId]);
  
  return (
    <VideoContext.Provider value={ videoContextValues }>
      { children }
    </VideoContext.Provider>
  )
}

export default VideoProvider;
